import constate from 'constate';

export type CreateSpreadsheetResponse = {
  id: string;
  spreadsheetUrl: string;
};

export type GetSpreadsheetValuesResponse = {
  values: string[][];
};

export type SpreadsheetAPI = {
  createSpreadsheet: (args: {
    title: string;
    values: string[][];
  }) => Promise<CreateSpreadsheetResponse>;
  getSpreadsheetValues: (
    spreadsheetId: string
  ) => Promise<GetSpreadsheetValuesResponse>;
};

export type UseEditTransactionRule = {
  spreadsheetApi: SpreadsheetAPI;
};

const noop = () => null;

const useTableTools = ({
  spreadsheetApi = {
    createSpreadsheet: noop,
    getSpreadsheetValues: noop,
  },
}: UseEditTransactionRule) => {
  return {
    spreadsheetApi,
  };
};

export const [TableToolsProvider, useTableToolsContext] =
  constate(useTableTools);
